import script from "./UnidadeCriarEditar.vue?vue&type=script&setup=true&lang=js"
export * from "./UnidadeCriarEditar.vue?vue&type=script&setup=true&lang=js"

import "./UnidadeCriarEditar.vue?vue&type=style&index=0&id=6f5b6cc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f5b6cc8"]])

export default __exports__